import React, { useRef } from 'react';
import { toast } from 'react-toastify';

const ALLOWED = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_BYTES = 5 * 1024 * 1024;

const ToolPhotoInput = ({ file, previewUrl, onChange, onRemove, disabled }) => {
  const inputRef = useRef(null);

  const pick = () => inputRef.current?.click();

  const handleSelect = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!ALLOWED.includes(f.type)) {
      toast.error('Solo JPG, PNG o WebP.');
      return;
    }
    if (f.size > MAX_BYTES) {
      toast.error('Máximo 5MB.');
      return;
    }
    onChange(f, URL.createObjectURL(f));
  };

  const showPreview = previewUrl || (file ? URL.createObjectURL(file) : null);

  return (
    <div className="tool-photo-input">
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleSelect}
        style={{ display: 'none' }}
        disabled={disabled}
      />
      {showPreview ? (
        <div className="position-relative d-inline-block">
          <img
            src={showPreview}
            alt="Vista previa"
            style={{
              width: 120, height: 120, objectFit: 'cover',
              borderRadius: 8, border: '1px solid #dee2e6'
            }}
          />
          {!disabled && (
            <button
              type="button"
              className="btn btn-sm btn-light position-absolute top-0 end-0 p-1"
              style={{ borderRadius: '50%', boxShadow: '0 2px 4px rgba(0,0,0,0.15)' }}
              onClick={onRemove}
              title="Quitar foto"
            >
              <i className="bi bi-x text-danger" />
            </button>
          )}
        </div>
      ) : (
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={pick}
          disabled={disabled}
          style={{
            width: 120, height: 120, borderRadius: 8,
            borderStyle: 'dashed', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <i className="bi bi-camera fs-3 text-muted" />
          <small className="text-muted mt-1">Agregar foto</small>
        </button>
      )}
      {showPreview && !disabled && (
        <div className="mt-2">
          <button type="button" className="btn btn-sm btn-link p-0" onClick={pick}>
            <i className="bi bi-arrow-repeat me-1" />Cambiar
          </button>
        </div>
      )}
    </div>
  );
};

export default ToolPhotoInput;
